import { ApiServiceBase } from '../../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Observable } from 'rxjs';
import { MediaTypeFileTypeModel } from 'src/app/core/models/reference-model/reference-media-model';

@Injectable({
  providedIn: 'root'
})
export class MediaTypeFileTypeService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/media"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getAll(): Observable<MediaTypeFileTypeModel[]> {
    return this.httpGet<any>(this.REFERENCE_PATH + "/mediatypefiletype", null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }

}